// extracted by mini-css-extract-plugin
module.exports = {"switch":"ToggleSwitch_switch__2UokS","slider":"ToggleSwitch_slider__1bg_2"};